// extracted by mini-css-extract-plugin
export default {"root":"ShippingDestinationSelect_root__jW0E+","label":"ShippingDestinationSelect_label__o+6us label","select":"ShippingDestinationSelect_select__tHewc"};